var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Form',{attrs:{"form":_vm.form,"purpose":"edit","route":`2-lab-reports/${_vm.$route.params.id}`}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }